import { createContext, useContext } from 'react';
import type { PageUISection } from '../../../utils/PageUI/pageUI';

export type PageUIMapHover = {
  onSectionHover: (section: PageUISection) => void;
  onSectionHoverEnd: () => void;
};

/**
 * Lets section components highlight their trail on a map without layout depending on @alltrails/maps. Pages with a map
 * provide the real implementation from @alltrails/maps; everywhere else the defaults are no-ops. Typed on the section,
 * not on the map's trail type, so layout needs nothing from maps.
 */
export const PageUIMapHoverContext = createContext<PageUIMapHover>({
  onSectionHover: () => {},
  onSectionHoverEnd: () => {}
});

export const usePageUIMapHover = () => useContext(PageUIMapHoverContext);
